import type { FC } from 'react';

import { PiqueLogo } from './pique-logo';
import { modalHeaderWrapper } from './share.css';

export const ModalHeader: FC<{
  title: string;
  subTitle: string;
}> = ({ title, subTitle }) => {
  return (
    <header className={modalHeaderWrapper}>
      <PiqueLogo className="logo" />
      <p className="title">{title}</p>
      <p className="subtitle">{subTitle}</p>
    </header>
  );
};
